import React from 'react';

import Modal from 'components/v2/Modal';

import styles from './AdminModal.module.css';

const AdminModal = (props) => <Modal {...props} className={styles.adminModal} />;

export default AdminModal;
